"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.YouTube = exports.Twitter = exports.TikTok = exports.Pinterest = exports.Instagram = exports.Facebook = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var FacebookSvg = function FacebookSvg(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("title", null, "Facebook"), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M271 858.69C210.31 848 163.89 795.12 163.89 731.56c0-70.71 57.85-128.56 128.56-128.56S421 660.85 421 731.56c0 63.56-46.42 116.42-107.13 127.13l-7.14-5.69h-28.57Z",
    transform: "translate(-163.89 -603)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m342.44 767.27 5.71-35.71h-34.28v-25c0-10 3.57-17.86 19.28-17.86h16.43v-32.85C340.29 654.42 330.3 653 321 653c-29.28 0-50 17.86-50 50v28.57h-32.12v35.71H271V858a108.2 108.2 0 0 0 42.85 0v-90.7Z",
    transform: "translate(-163.89 -603)",
    style: {
      fill: "#0c1e34"
    }
  }));
};

FacebookSvg.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "-38 -40 340 340"
};

var InstagramSvg = function InstagramSvg(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("title", null, "Instagram"), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#24292D",
    d: "M8 3.991c1.469 0 1.643.006 2.223.032 1.49.068 2.187.776 2.254 2.255.027.58.032.754.032 2.222 0 1.47-.005 1.643-.032 2.223-.068 1.478-.762 2.187-2.254 2.254-.58.027-.754.033-2.223.033-1.468 0-1.643-.006-2.222-.033-1.495-.068-2.187-.778-2.255-2.255-.027-.58-.032-.753-.032-2.222 0-1.468.006-1.642.032-2.222.068-1.48.763-2.187 2.255-2.255.58-.026.754-.032 2.222-.032zM8 3c-1.494 0-1.68.006-2.267.033-1.998.092-3.108 1.2-3.2 3.2-.027.586-.033.773-.033 2.267 0 1.494.006 1.681.033 2.268.092 1.997 1.2 3.107 3.2 3.199.586.027.773.033 2.267.033 1.494 0 1.681-.006 2.268-.033 1.995-.092 3.108-1.2 3.199-3.2.027-.586.033-.773.033-2.267 0-1.494-.006-1.68-.033-2.267-.09-1.996-1.2-3.108-3.199-3.2C9.681 3.006 9.494 3 8 3zm0 2.676a2.824 2.824 0 1 0 0 5.648 2.824 2.824 0 0 0 0-5.648zm0 4.657a1.833 1.833 0 1 1 0-3.666 1.833 1.833 0 0 1 0 3.666zm2.936-5.429a.66.66 0 1 0 0 1.32.66.66 0 0 0 0-1.32z"
  }));
};

InstagramSvg.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16"
};

var PinterestSvg = function PinterestSvg(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("title", null, "Pinterest"), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#24292D",
    d: "M8 2a6 6 0 0 0-2.186 11.587c-.053-.474-.1-1.203.02-1.72l.704-2.983s-.18-.36-.18-.891c0-.834.484-1.457 1.086-1.457.511 0 .759.385.759.845 0 .514-.327 1.284-.497 1.998-.142.597.3 1.084.888 1.084 1.067 0 1.886-1.124 1.886-2.747 0-1.437-1.032-2.442-2.506-2.442-1.707 0-2.708 1.281-2.708 2.604 0 .515.198 1.069.446 1.369a.18.18 0 0 1 .042.172l-.167.68c-.026.11-.087.134-.201.081-.75-.349-1.218-1.444-1.218-2.324 0-1.893 1.375-3.631 3.965-3.631 2.081 0 3.699 1.483 3.699 3.465 0 2.068-1.304 3.732-3.114 3.732-.608 0-1.18-.316-1.375-.689l-.374 1.426c-.136.522-.501 1.175-.746 1.573A6 6 0 1 0 8 2z"
  }));
};

PinterestSvg.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16"
};

var YouTubeSvg = function YouTubeSvg(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("title", null, "Youtube"), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#24292D",
    d: "M11.807 3.102c-1.802-.136-5.815-.136-7.615 0C2.244 3.25 2.014 4.558 2 8c.014 3.436.242 4.75 2.192 4.898 1.8.136 5.813.136 7.615 0C13.756 12.75 13.985 11.442 14 8c-.014-3.436-.242-4.75-2.193-4.898zM6 10V6l4 1.997L6 10z"
  }));
};

YouTubeSvg.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16"
};

var TikTokSvg = function TikTokSvg(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("title", null, "TikTok"), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#24292D",
    d: "M2081 0c55 473 319 755 778 785v532c-266 26-499-61-770-225v995c0 1264-1378 1659-1932 753-356-583-138-1606 1004-1647v561c-87 14-180 36-265 65-254 86-398 247-358 531 77 544 1075 705 992-358V1h551z"
  }));
};

TikTokSvg.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "-220 -670 3900 4524"
};

var TwitterSvg = function TwitterSvg(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("title", null, "Twitter"), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.5 4.696c-.405.185-.84.309-1.296.365.466-.287.824-.74.992-1.28a4.453 4.453 0 0 1-1.433.56 2.227 2.227 0 0 0-1.647-.73c-1.457 0-2.528 1.394-2.199 2.841-1.875-.096-3.538-1.017-4.651-2.417-.591 1.04-.307 2.4.698 3.09a2.205 2.205 0 0 1-1.022-.29c-.024 1.072.725 2.075 1.81 2.298a2.208 2.208 0 0 1-1.02.04c.288.919 1.121 1.588 2.11 1.606a4.457 4.457 0 0 1-3.342.96 6.274 6.274 0 0 0 3.46 1.039c4.19 0 6.557-3.629 6.414-6.884.44-.326.823-.734 1.126-1.198z"
  }));
};

TwitterSvg.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16"
};

var Facebook = function Facebook() {
  return /*#__PURE__*/_react["default"].createElement(FacebookSvg, null);
};

exports.Facebook = Facebook;

var Instagram = function Instagram() {
  return /*#__PURE__*/_react["default"].createElement(InstagramSvg, null);
};

exports.Instagram = Instagram;

var Pinterest = function Pinterest() {
  return /*#__PURE__*/_react["default"].createElement(PinterestSvg, null);
};

exports.Pinterest = Pinterest;

var YouTube = function YouTube() {
  return /*#__PURE__*/_react["default"].createElement(YouTubeSvg, null);
};

exports.YouTube = YouTube;

var TikTok = function TikTok() {
  return /*#__PURE__*/_react["default"].createElement(TikTokSvg, null);
};

exports.TikTok = TikTok;

var Twitter = function Twitter() {
  return /*#__PURE__*/_react["default"].createElement(TwitterSvg, null);
};

exports.Twitter = Twitter;